import React from 'react';
import { 
    Flex, 
    Text,
    Image,
    useMediaQuery,
    useTheme
} from '@chakra-ui/react';
import icon1 from '../assets/icons/amenidades/icon1.svg';
import icon2 from '../assets/icons/amenidades/icon2.svg';
import icon3 from '../assets/icons/amenidades/icon3.svg';
import icon4 from '../assets/icons/amenidades/icon4.svg';
import icon5 from '../assets/icons/amenidades/icon5.svg';
import icon6 from '../assets/icons/amenidades/icon6.svg';

const Amenidades = () => {
    const { breakpoints } = useTheme();
    const [isGreaterThanMd] = useMediaQuery(`(min-width: ${breakpoints.lg})`);
    
    return ( 
        <Flex flexDirection={"column"} color={"#545454"} w={"100%"}>
            <Flex justifyContent={"center"} mt={10} mb={10}>
                <Text fontSize={isGreaterThanMd ? '38px' : '22px'} fontWeight={600} textAlign={isGreaterThanMd ? "start" : "center"}>Muebles que se ajustan a tus necesidades y a tu presupuesto</Text>
            </Flex>
            <Flex mb={10} flexDirection={"column"}>
                <Flex justifyContent={"center"} alignItems={"center"} w={"100%"} flexDirection={isGreaterThanMd ? "row" : "column"}>
                    <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "end" : "center"} mb={isGreaterThanMd ? 0 : 10}>
                        <Flex flexDirection={"column"} alignItems={"center"}>
                            <Image src={icon1} w={'179px'} h={'103px'} alt='icon1'/>
                            <Text fontSize='20px' fontWeight={400} mt={5}>Cocinas</Text>
                        </Flex>
                    </Flex>
                    <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={"center"} mb={isGreaterThanMd ? 0 : 10}>
                        <Flex flexDirection={"column"} alignItems={"center"}>
                            <Image src={icon2} w={'87px'} h={'112px'} alt='icon2'/>
                            <Text fontSize='20px' fontWeight={400} mt={5}>Clósets</Text>
                        </Flex>
                    </Flex>
                    <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "start" : "center"}>
                        <Flex flexDirection={"column"} alignItems={"center"}>
                            <Image src={icon3} w={'112px'} h={'107px'} alt='icon3'/>
                            <Text fontSize='20px' fontWeight={400} mt={5}>Canceles de baño</Text>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex justifyContent={"center"} alignItems={"center"} w={"100%"} mt={10} flexDirection={isGreaterThanMd ? "row" : "column"}>
                    <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "end" : "center"} mb={isGreaterThanMd ? 0 : 10}>
                        <Flex flexDirection={"column"} alignItems={"center"}>
                            <Image src={icon4} w={'131px'} h={'106px'} alt='icon4'/>
                            <Text fontSize='20px' fontWeight={400} mt={5} textAlign={"center"}>Cortinas y persianas</Text>
                        </Flex>
                    </Flex>
                    <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={"center"} mb={isGreaterThanMd ? 0 : 10}>
                        <Flex flexDirection={"column"} alignItems={"center"} paddingTop={isGreaterThanMd ? 10 : 0}>
                            <Image src={icon5} w={'166px'} h={'61px'} alt='icon5'/>
                            <Text fontSize='20px' fontWeight={400} mt={isGreaterThanMd ? '1.6rem' : 5}>Muebles</Text>
                        </Flex>
                    </Flex>
                    <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "start" : "center"} mb={isGreaterThanMd ? 0 : 10}>
                        <Flex flexDirection={"column"} alignItems={"center"}>
                            <Image src={icon6} w={'164px'} h={'122px'} alt='icon6'/>
                            <Text fontSize='20px' fontWeight={400} mt={isGreaterThanMd ? 0 : 5} textAlign={"center"}>Artículos decorativos</Text>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
}
 
export default Amenidades;